import { render, staticRenderFns } from "./JVxeDemo1.vue?vue&type=template&id=7731bda2&scoped=true"
import script from "./JVxeDemo1.vue?vue&type=script&lang=js"
export * from "./JVxeDemo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7731bda2",
  null
  
)

export default component.exports